import React, { useState, useEffect } from 'react';
import Button from "app/components/CustomButtons/Button.js";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { makeStyles } from "@material-ui/core/styles";
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import GridItem from "app/components/Grid/GridItem.js";
import Grid from '@material-ui/core/Grid'
import TextField from '@mui/material/TextField';
import { useHasChanged } from 'app/hooks/useHasChanged';

const useStyles = makeStyles(() => ({
    paper: { minWidth: "1000px" },
}));

//React export function used to Create, Edit and Delete Contact Details function
export default function ContactDetails(props) {
    const { buttonColour, addressId, contactDetails, contactDetailsUseType } = props;
    const [open, setOpen] = useState(false);
    const [isSuccess, setisSuccess] = useState("");
    const [isError, setisError] = useState("");
    const classes = useStyles();
    const [contactDetailRows, setContactDetailRows] = useState([]);
    const [canDelete, setCanDelete] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    
    const hasAddressIdChanged = useHasChanged(addressId);

    useEffect(() => {
        if (hasAddressIdChanged) {
            axios
            .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetFullAddressByID`, { params: { Id: addressId } })
            .then((res) => {
                //assign id property for data grid to work.
                let rowid = 0;
                res.data.contactDetails.forEach((contactDetail) => {
                    contactDetail.addressId = addressId;
                    if (contactDetailsUseType !== undefined) {
                        contactDetail.useType = contactDetailsUseType;
                    }
                    contactDetail.id = rowid;
                    rowid++;
                });
                setContactDetailRows(res.data.contactDetails);
                contactDetails({ addressId: addressId, contacts: res.data.contactDetails });
            })
            .catch((e) => {
                console.log('error happened');
            });
        }
    }, [addressId, contactDetails, contactDetailsUseType, hasAddressIdChanged]);

    const columns = [
        {
            field: 'contactID',
            headerName: 'contactID',
            width: 50,
            type: 'number',
            hide: true
        },
        {
            field: 'name',
            headerName: 'Name',
            width: 200
        },
        {
            field: 'telephone',
            headerName: 'Telephone',
            width: 200
        },
        {
            field: 'mobile',
            headerName: 'Mobile',
            width: 200
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 300
        }
    ];

    const handleClickOpen = () => {
        setOpen(true);
        setCanDelete(false);
    };

    const handleClose = () => {
        setOpen(false);
        setCanDelete(false);
        setSelectedRow();
    };

    const handleNameChange = (e) => {
        let newSelectedRow = { ...selectedRow };
        newSelectedRow.name = e.target.value;
        setSelectedRow(newSelectedRow);
    };

    const handleTelephoneChange = (e) => {
        let newSelectedRow = { ...selectedRow };
        newSelectedRow.telephone = e.target.value;
        setSelectedRow(newSelectedRow);
    };

    const handleMobileChange = (e) => {
        let newSelectedRow = { ...selectedRow };
        newSelectedRow.mobile = e.target.value;
        setSelectedRow(newSelectedRow);
    };

    const handleEmailChange = (e) => {
        let newSelectedRow = { ...selectedRow };
        newSelectedRow.email = e.target.value;
        setSelectedRow(newSelectedRow);
    };

    const handleAddRow = (e) => {
        let newRow = {
            name: "",
            telephone: "",
            mobile: "",
            email: ""
        }
        setSelectedRow(newRow);
    };

    const handleUpdateRow = (e) => {
        let newSelectedRow = { ...selectedRow };
        let newContactDetailRows = [...contactDetailRows];

        if (newSelectedRow.id === undefined) {
            newSelectedRow.id = newContactDetailRows.length;
            newSelectedRow.serviceAction = "Add";
            newSelectedRow.addressId = addressId;
            newSelectedRow.isDataDirty = true;
            if (contactDetailsUseType !== undefined) {
                newSelectedRow.useType = contactDetailsUseType;
            }
            newContactDetailRows.push(newSelectedRow);
        }
        else {
            var rowToUpdate = newContactDetailRows.findIndex((contactDetails) => {
                return contactDetails.id === newSelectedRow.id;
            })

            newContactDetailRows[rowToUpdate].name = newSelectedRow.name;
            newContactDetailRows[rowToUpdate].telephone = newSelectedRow.telephone;
            newContactDetailRows[rowToUpdate].mobile = newSelectedRow.mobile;
            newContactDetailRows[rowToUpdate].email = newSelectedRow.email;
            newContactDetailRows[rowToUpdate].serviceAction = "Update";
            newContactDetailRows[rowToUpdate].isSelected = false;
            newContactDetailRows[rowToUpdate].isDataDirty = true;
            if (contactDetailsUseType !== undefined) {
                newSelectedRow.useType = contactDetailsUseType;
            }
        }

        setContactDetailRows(newContactDetailRows);

        setSelectedRow(null);
    };

    const handleRowSelection = (e) => {
        if (e.length > 0) {
            setCanDelete(true);
        }
        else {
            setCanDelete(false);
        }

        let newContactDetailRows = [...contactDetailRows];

        if (e.length === 1) {
            let selectedIndex = newContactDetailRows.findIndex((contactDetail) => {
                return contactDetail.id === e[0];
            });

            setSelectedRow(newContactDetailRows[selectedIndex]);
        }
        else {
            setSelectedRow(null);
        }

        newContactDetailRows.forEach((contactDetail) => {
                if (e.includes(contactDetail.id)) {
                    contactDetail.isSelected = true;
                }
                else {
                    contactDetail.isSelected = false;
                }
        });

        setContactDetailRows(newContactDetailRows);
    };

    const handleDeleteRow = (e) => {
        let newContactDetailRows = [...contactDetailRows];

        newContactDetailRows.forEach((contactDetails) => {
            if (contactDetails.isSelected === true) {
                contactDetails.serviceAction = "Delete";
                contactDetails.isDataDirty = true;
            }
        });

        setSelectedRow(null);
        setContactDetailRows(newContactDetailRows);
    };

    //Handle the on submit request to post the new address 
    const onSubmit = (e) => {
        e.preventDefault();

        setisSuccess('');

        const addressIdKey = "addressId";
        const addressIdValue = addressId
        contactDetailRows[addressIdKey] = addressIdValue;
        const formDataJsonString = JSON.stringify(contactDetailRows);

        axios
            .post(
                `${process.env.REACT_APP_API_ENDPOINT}/api/contact/PostContact`,
                formDataJsonString
            )
            .then(function (response) {
                if (response.data === "Contacts added successfully.") {
                    setisSuccess(response.data);
                    axios
                        .get(`${process.env.REACT_APP_API_ENDPOINT}/api/address/GetFullAddressByID`, { params: { Id: addressId } })
                        .then((res) => {
                            //assign id property for data grid to work.
                            let rowid = 0;
                            res.data.contactDetails.forEach((contactDetail) => {
                                contactDetail.addressId = addressId;
                                contactDetail.id = rowid;
                                rowid++;
                            });
                            setContactDetailRows(res.data.contactDetails);
                            contactDetails({ addressId: addressId, contacts: res.data.contactDetails });
                        })
                        .catch((e) => {
                            console.log('error happened');
                        });

                } else {
                    setisError(response.data);
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    return (
        <div>
            <Button color={buttonColour} onClick={handleClickOpen} style={{ marginTop: '9px' }}>
                Contact Details
            </Button>
            <Dialog open={open} onClose={handleClose} classes={{ paper: classes.paper }}>
                <form onSubmit={onSubmit}>
                    <DialogTitle>Contact Details</DialogTitle>
                    <GridItem xs={12}>
                        <div style={{ height: 400, width: '100%' }}>
                            <DataGrid
                                checkboxSelection
                                rows={contactDetailRows.filter((contactDetail) => {
                                    return contactDetail.serviceAction !== "Delete";
                                })}
                                onSelectionModelChange={handleRowSelection}
                                columns={columns} />
                        </div>
                    </GridItem>
                    {selectedRow && (<Grid container>
                        <Grid item xs={3}>
                            <TextField
                                id="name"
                                name="name"
                                label="Name"
                                InputLabelProps={{ shrink: true }}
                                type="text"
                                fullWidth
                                required
                                value={selectedRow.name}
                                onChange={handleNameChange}
                                style={{ marginLeft: '20px', marginTop: '20px' }}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                id="telephone"
                                name="telephone"
                                label="Telephone"
                                InputLabelProps={{ shrink: true }}
                                type="text"
                                fullWidth
                                value={selectedRow.telephone}
                                onChange={handleTelephoneChange}
                                style={{ marginLeft: '20px', marginTop: '20px' }}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <TextField
                                id="mobile"
                                name="mobile"
                                label="Mobile"
                                InputLabelProps={{ shrink: true }}
                                type="text"
                                fullWidth
                                value={selectedRow.mobile}
                                onChange={handleMobileChange}
                                style={{ marginLeft: '20px', marginTop: '20px' }}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextField
                                id="email"
                                name="email"
                                label="Email"
                                InputLabelProps={{ shrink: true }}
                                type="text"
                                fullWidth
                                value={selectedRow.email}
                                onChange={handleEmailChange}
                                style={{ marginLeft: '20px', marginTop: '20px' }}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button onClick={handleUpdateRow} style={{ marginLeft: '40px', marginTop: '25px' }} color="primary">Update</Button>
                        </Grid>
                    </Grid>)}
                    <DialogContent>
                        <div style={{ color: "green" }}>{isSuccess}</div>
                        <div style={{ color: "red" }}>{isError}</div>
                        {canDelete && (<Button onClick={handleDeleteRow} color="primary">Delete</Button>)}
                        <Button onClick={handleAddRow} color="primary">Add</Button>
                        <Button color={buttonColour} onClick={handleClose} style={{ float: "right" }}>Close</Button>
                        <Button color={buttonColour} type="submit" style={{ float: "right" }}>Save</Button>
                    </DialogContent>
                </form>
            </Dialog>
        </div>
    );
}